export default __webpack_public_path__ + "static/media/DAIF_Extra1_Screen1_in-end.0cf8c600.jpg";